var icon = require('vue-svgicon')
icon.register({
  'ks-icon-printer': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M91 22H35v18.67h56M95.67 64a4.67 4.67 0 1 1 4.66-4.67A4.67 4.67 0 0 1 95.67 64m-14 32.67H44.33V73.33h37.34m14-28H30.33a14 14 0 0 0-14 14v28H35V106h56V87.33h18.67v-28a14 14 0 0 0-14-14z"/>'
  }
})
